export const environment = {
  production: true,
  mockMode: false,
  apiBaseUrl: 'https://appli-back.logiciels-carbone14.fr',
  auth: {
    backOfficeUrl: 'https://appli-back.logiciels-carbone14.fr',
    authContextPath: '/auth',
    clientId: 'carbone14f',
    clientSecret: 'Partner1',
  },
};
